import styled from "styled-components";
import { Space, Image as AntImage } from "antd";
import { WarningFilled, QuestionFilled, IMG_QR } from "@assets";

export const MainContainer = styled.div`
  position: relative;
  min-height: 100vh;
`;
export const RootContainer = styled.div`
  padding: 16px;

  .ant-collapse {
    background-color: #fff;
    border: 1px solid #e1cce0;

    .ant-image {
      margin-bottom: 12px;
    }
  }

  .ant-collapse-header {
    flex-direction: row-reverse;
  }

  .ant-collapse-header-text {
    font-size: 14px;
    font-weight: bold;
  }

  @media screen and (max-width: 320px) {
    padding: 16px 8px;
  }
`;

export const Text = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #f9f9f9;
  text-align: center;
`;

export const QuestionIcon = styled(QuestionFilled)`
  margin-bottom: -2px;
  cursor: pointer;
`;

export const DigitBox = styled.div`
  margin-top: 16px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  grid-gap: 12px;
  text-align: center;

  .ant-space {
    gap: 4px !important;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 24px;
  position: relative;

  .ant-btn {
    height: 52px;
  }
`;

export const SpinWrapper = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledInput = styled.input`
  width: 20px !important;
  height: 30px !important;
  border-radius: 8px !important;
  text-align: center !important;
  border: 1px solid
    ${(props) => (props.status === "error" ? "red" : "transparent")} !important;
  font-size: 17px !important;
  background-color: #efefef;
  -moz-appearance: textfield;
  appearance: textfield;

  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;

export const SlideImage = styled.img.attrs({
  alt: "slide-img",
})`
  width: 100%;
  height: auto;
  object-fit: cover;
  cursor: pointer;
`;

export const SimpleSlideImage = styled.img.attrs({
  alt: "slide-img",
})`
  width: 278px;
  height: 127px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 8px;
`;

export const EmptyBox = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;

  .ant-btn-primary {
    height: 52px;
  }
`;

export const EmptyText = styled.div`
  padding: 0 15%;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: #fff;

  @media screen and (max-width: 360px) {
    padding: 0 12%;
  }
`;

export const WarningImage = styled(WarningFilled)`
  width: 50px;
  height: 50px;
`;

export const Container = styled.div`
  padding: 16px 16px;
  border-radius: 12px;
  background: #0e1017;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px solid #424242;
`;

export const Box = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ImageBox = styled.div`
  flex: 1;
  display: flex;
  grid-gap: 16px;
  align-items: center;
  justify-content: flex-start;

  @media screen and (max-width: 390px) {
    grid-gap: 12px;
  }

  @media screen and (max-width: 360px) {
    grid-gap: 10px;
  }

  @media screen and (max-width: 325px) {
    grid-gap: 8px;
  }
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 54px;
  border-radius: 12px;

  @media screen and (max-width: 350px) {
    width: 35px;
  }
  @media screen and (max-width: 325px) {
    width: 30px;
  }
`;

export const TypeText = styled.div`
  font-size: 16px;
  font-weight: 100;
  color: #f9f9f9;

  @media screen and (max-width: 390px) {
    font-size: 14px;
  }

  @media screen and (max-width: 360px) {
    font-size: 13px;
  }

  @media screen and (max-width: 325px) {
    font-size: 12px;
  }
`;

export const Divider = styled.div`
  width: 1px;
  border-right: 1px solid #f4f1eb;
  height: 33px;
`;

export const AmountBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
  align-items: flex-start;
  justify-content: center;
  padding-left: 20px;
`;

export const SmallText = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #9f9fa2;
  text-align: center;

  @media screen and (max-width: 325px) {
    font-size: 11px;
  }
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 100;
  color: #f9f9f9;
  text-align: center;

  @media screen and (max-width: 325px) {
    font-size: 12px;
  }
`;

export const GrayText = styled.span`
  font-size: 12px;
  font-weight: normal;
  color: #686B6E;
  text-align: center;

  @media screen and (max-width: 325px) {
    font-size: 11px;
  }
`;

export const TextWrapper = styled.div`
  padding-top: 8px;
  font-size: 12px;
  font-weight: 300px;
  color: #f9f9f9;
`;

export const AccountInfo = styled(Space)`
  width: 100%;
  margin-top: 7px;
  background: #212224;
  display: flex;
  align-items: center;
  border-radius: 8px;

  .ant-space-item:nth-child(1) {
    flex: 1;
  }

  .ant-space {
    flex-direction: column;
    align-items: flex-start;
  }

  svg {
    width: 24px;
    cursor: pointer;
  }
  padding: 5px 0px;

  ${Text} {
    padding-left: 8px;
  }
`;

export const AccountNameText = styled(SmallText)`
  color: #f9f9f9;
  text-align: center;
  padding-left: 8px;
`;

export const Copy = styled.div`
  color: #e8a442;
  cursor: pointer;
  font-weight: 300;
  font-size: 12px;
  padding-right: 8px;
`;

export const SimpleButton = styled.div`
  margin: 16px auto;
  width: 102px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #f9f9f9;
  font-weight: 600;
  font-size: 10px;
  border-radius: 12px;
  border: 1px solid #d28a28;
  gap: 8px;
  padding: 1px 2px 3px 3px;
`;

export const QRCodeContainer = styled.div`
  width: 100%;
  margin-top: 7px;
  background: #212224;
  display: flex;
  align-items: center;
  border-radius: 8px;
  gap: 60px;

  padding: 10px 0px;

  @media screen and (max-width: 450px) {
    gap: 0px;
    justify-content: space-between;
  }
`;

export const QRCodeImage = styled(AntImage).attrs({
  alt: "QR",
  src: IMG_QR,
  preview: false,
})`
  width: 42px;
  height: 42px;
  padding-left: 10px;
`;

export const QRCodeText = styled.div`
  color: #e8a442;
  font-size: 12px;
  line-height: 15px;
  padding-right: 10px;
  cursor: pointer;

  @media screen and (max-width: 350px) {
    font-size: 10px;
  }
`;

export const Wrapper = styled.div`
  min-width: 60px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const ScreenShotBox = styled.div`
  margin: 24px 0 0;
`

export const PalePurpleWrapper = styled.div`
  margin: 12px 0 24px;
  padding: 16px;
  border-radius: 5px;
  border: 1px solid var(--linear-blur, #D78E28);
  background: var(--Natural-6, #212224) !important;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;

  svg{
    width: 24px;
    height: 24px;
  }

  @media screen and (max-width: 400px) {
    padding: 12px;
  }
`

export const UploadText = styled.p`
color: var(--Natural-3, #9F9FA2);
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 150% */
`

export const RowFlex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export const ColFlex = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

`

export const BlackText = styled.p`
  color: var(--Natural-2, #CFCFD1);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  text-align: left;

  @media screen and (max-width: 400px) {
    font-size: 14px;
  }
`

export const ChangeBtn = styled.div`
  color: var(--Brand-Color, #FFB829);
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  
  margin-bottom: 26px;
  width: 60px;
  font-size: 14px;
`

export const SSWarningText = styled.div`
color: var(--Green-4, #4CAB3D);
text-align: center;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 16px; /* 133.333% */
`